import { Box, BoxProps } from '@chakra-ui/react';

/**
 * DS page container — mirrors mockup `.page`:
 * max-width 1320, centered, responsive padding (32/24/16). Use as the root
 * wrapper for content-page screens (Documents, Upload, Connections, etc.)
 * so every page shares identical width + gutters.
 */
export const PageContainer = ({ children, ...rest }: BoxProps) => (
  <Box
    w='100%'
    maxW='1320px'
    mx='auto'
    px={{ base: 4, md: 6, xl: 8 }}
    pt={{ base: 5, md: 6, xl: 8 }}
    pb={{ base: 8, md: 12, xl: 16 }}
    {...rest}
  >
    {children}
  </Box>
);

export default PageContainer;
